import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "@/components/feature/BottomNav";
import { reviews } from "@/mocks/massage";

export default function ReviewsPage() {
  const navigate = useNavigate();
  const [liked, setLiked] = useState<Set<number>>(new Set());

  const toggleLike = (id: number) => {
    setLiked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const avg = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <div className="flex flex-col min-h-screen bg-stone-50 pb-20" style={{ maxWidth: 480, margin: "0 auto" }}>
      <div className="px-4 pt-10 pb-4" style={{ background: "linear-gradient(160deg, #3d2c22 0%, #6b4230 80%)" }}>
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/")} className="w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className="ri-arrow-left-line text-white text-xl" />
          </button>
          <h1 className="text-white text-base font-bold">用户评价</h1>
        </div>
        <div className="flex items-center gap-6 mt-4 ml-1">
          <div className="text-center">
            <p className="text-4xl font-bold text-white">{avg}</p>
            <div className="flex items-center gap-0.5 mt-1 justify-center">
              {[1,2,3,4,5].map((s) => (
                <div key={s} className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-xs" />
                </div>
              ))}
            </div>
            <p className="text-white/60 text-xs mt-0.5">综合评分</p>
          </div>
          <div className="flex-1 space-y-1.5">
            {[5,4,3,2,1].map((s) => {
              const cnt = reviews.filter(r => r.rating === s).length;
              const pct = Math.round((cnt / reviews.length) * 100);
              return (
                <div key={s} className="flex items-center gap-2">
                  <span className="text-white/70 text-xs w-3">{s}</span>
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400" style={{ fontSize: 10 }} />
                  </div>
                  <div className="flex-1 h-1.5 rounded-full bg-white/20">
                    <div className="h-full rounded-full bg-amber-400" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="text-white/50 text-xs w-6">{pct}%</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 pt-4 space-y-3">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={r.avatar} alt={r.user} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-stone-800">{r.user}</span>
                  <span className="text-xs text-stone-400">{r.date}</span>
                </div>
                <div className="flex items-center gap-1 mt-0.5">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className={i < r.rating ? "ri-star-fill text-amber-400" : "ri-star-line text-stone-300"} style={{ fontSize: 11 }} />
                    </div>
                  ))}
                  <span className="text-xs text-stone-400 ml-1">{r.service}</span>
                </div>
              </div>
            </div>
            <p className="text-sm text-stone-600 leading-relaxed mb-3">{r.content}</p>
            {r.images.length > 0 && (
              <div className="flex gap-2 mb-3">
                {r.images.map((img, idx) => (
                  <div key={idx} className="w-20 h-20 rounded-xl overflow-hidden">
                    <img src={img} alt="评价图片" className="w-full h-full object-cover object-top" />
                  </div>
                ))}
              </div>
            )}
            <div className="flex items-center justify-between">
              <div className="flex flex-wrap gap-1.5">
                {r.tags.map((tag) => (
                  <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-stone-50 text-stone-500 border border-stone-100">{tag}</span>
                ))}
              </div>
              <button
                onClick={() => toggleLike(r.id)}
                className="flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${liked.has(r.id) ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-sm`}
                    style={{ color: liked.has(r.id) ? "#c2855a" : "#9ca3af" }} />
                </div>
                <span className="text-xs" style={{ color: liked.has(r.id) ? "#c2855a" : "#9ca3af" }}>
                  {r.likes + (liked.has(r.id) ? 1 : 0)}
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>
      <BottomNav />
    </div>
  );
}
